import React from "react";
import { createUseStyles } from "react-jss";
import classNames from "classnames";
import PropTypes from "prop-types";
import { sendMetriks } from "Services/sendMetriks";

const useStyles = createUseStyles((theme) => ({
	root: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		height: "24px",
		fontFamily: "Inter-SemiBold",
		backgroundColor: "#FFF7ED",
		color: theme.palette.colors.orange,
		border: `0.5px solid #FED7AA`,
		fontSize: "12px",
		lineHeight: "16px",
		borderRadius: "128px",
		padding: "0 8px",
	},
	purple: {
		borderColor: "#C3A9FF",
		color: theme.palette.colors.purplishBlue,
		backgroundColor: "#F5F1FF",
	},
}));

const ExclusiveV2 = (props) => {
	const { children, color } = props;
	const classes = useStyles();

	const onClick = () => {
		if (color === "purple") {
			sendMetriks("CLICK_ACTION_NEW_TARIFF");
		} else {
			sendMetriks("CLICK_EXCLUSIVE_NEW_TARIFF");
		}
	};

	return (
		<div
			className={classNames(classes.root, {
				[classes.purple]: color === "purple",
			})}
			onClick={onClick}
		>
			{children}
		</div>
	);
};
ExclusiveV2.propTypes = {
	color: PropTypes.string,
};
export default ExclusiveV2;
